import { getServerBaseURL } from 'src/utils/base';
import { request } from '../boot/request';

const baseURL = getServerBaseURL('ordercart');

const getCheckoutOption = params => {
  params = params || {};
  return request({
    url: '/checkoutOption',
    method: 'POST',
    data: params,
  });
};

const getGoCheckout = params => {
  params = params || {};
  return request({
    url: '/checkout',
    method: 'GET',
    params,
  });
};

const getEWalletsPaymentId = params => {
  params = params || {};
  return request({
    url: '/getPaymentMethodId',
    method: 'POST',
    data: params,
  });
};

const getTableNumber = params => {
  params = params || {};
  return request({
    baseURL,
    url: '/tableNumber/searchTableNumber',
    method: 'GET',
    params,
  });
};

// 获取当前可用物流
const availableShippingMethods = params => {
  params = params || {};
  return request({
    url: '/availableShippingMethods',
    method: 'GET',
    params,
  });
};

// 选择切换物流
const changeShippingMethod = params => {
  params = params || {};
  return request({
    url: '/changeShippingMethod',
    method: 'POST',
    data: params,
  });
};

// 获取voucher列表
const getVoucherList = params => request({
  method: 'POST',
  url: '/availableVouchers',
  data: params
})
// 使用voucher
const reqUseVoucher = data => request({
  method: 'POST',
  url: '/changeVoucher',
  data
})
// 移除当前使用voucher
const reqDelVoucher = params => request({
  method: 'GET',
  url: '/removeVouchers',
  params
})

// 检测ovo号码是否正确
const checkPhoneNumber = data => request({
  method: 'Post',
  url: '/inquiryOvoPhone',
  data
})

const getApartAddrs = () => request({
  method: 'POST',
  url: '/getProductStoreApartmentAddress'
})

export {
  reqDelVoucher,
  reqUseVoucher,
  getVoucherList,
  getCheckoutOption,
  getGoCheckout,
  getEWalletsPaymentId,
  getTableNumber,
  availableShippingMethods,
  changeShippingMethod,
  checkPhoneNumber,
  getApartAddrs
};
